import { QUERY_PARAMS } from 'constants/queryNames';

import type { TStAttributionParams } from '../types/stAttributionParams';

export const ST_ATTRIBUTION_PARAM_MAP: ReadonlyArray<{
  field: Exclude<keyof TStAttributionParams, 'affSub1'>;
  query: string;
}> = [
  { field: 'source', query: QUERY_PARAMS.SOURCE },
  { field: 'affSub2', query: QUERY_PARAMS.AFF_SUB2 },
  { field: 'affSub3', query: QUERY_PARAMS.AFF_SUB3 },
  { field: 'affSub4', query: QUERY_PARAMS.AFF_SUB4 },
  { field: 'affSub5', query: QUERY_PARAMS.AFF_SUB5 },
  { field: 'affSub6', query: QUERY_PARAMS.AFF_SUB6 },
  { field: 'affSub7', query: QUERY_PARAMS.AFF_SUB7 },
  { field: 'affSub8', query: QUERY_PARAMS.AFF_SUB8 },
  { field: 'affSub9', query: QUERY_PARAMS.AFF_SUB9 },
  { field: 'affSub10', query: QUERY_PARAMS.AFF_SUB10 },
];

export const ST_ATTRIBUTION_AFF_SUB1_QUERY_PARAMS = [QUERY_PARAMS.AFF_SUB1, QUERY_PARAMS.AFF_SUB] as const;
